import React, { FC, useEffect, useState } from 'react';
import CookiesConsentPopup from './CookiesConsentPopup';
import CookiesConsentConfig from './CookiesConsentConfig';
import getCookie from '../../utils/getCookie';
import { IConsents, consentPopupsEvents } from './types';
import { IConfig } from '../../types/config';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

const CookiesConsent: FC<{ isPolicyView?: boolean; config: IConfig; language: string }> = ({
  isPolicyView,
  config,
  language,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showConfigPopup, setShowConfigPopup] = useState(false);

  useEffect(() => {
    const cookie = getCookie('cookieConsent');
    if (!cookie && !isPolicyView) {
      setShowPopup(true);
    }
  }, []);

  useEffect(() => {
    const toggleCookiePopups = (event: MessageEvent) => {
      if (event.origin === window.location.origin) {
        switch (event.data.eventName) {
          case consentPopupsEvents.OPENCONFIGPOPUP:
            setShowConfigPopup(true);
            break;
          case consentPopupsEvents.CLOSECONFIGPOPUP:
            setShowConfigPopup(false);
            break;
          case consentPopupsEvents.OPENMAINPOPUP:
            setShowPopup(true);
            break;
          case consentPopupsEvents.CLOSEMAINPOPUP:
            setShowPopup(false);
            break;
        }
      }
    };

    window.addEventListener('message', toggleCookiePopups, false);

    return () => {
      window.removeEventListener('message', toggleCookiePopups);
    };
  }, []);

  const setCookie = (consents: IConsents) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    document.cookie = `cookieConsent=${JSON.stringify(consents)}; expires=${date.toUTCString()}; path=/;`;
    location.reload();
  };

  return (
    <section className={`cookies-consent-section`}>
      {showPopup ? <CookiesConsentPopup config={config} setCookie={setCookie} language={language} /> : null}
      {showConfigPopup ? <CookiesConsentConfig config={config} setCookie={setCookie} language={language} /> : null}
    </section>
  );
};

export default CookiesConsent;
